export const AUTH_USER = 'auth_user';
export const UNAUTH_USER = 'unauth_user';
export const AUTH_ERROR = 'auth_error';
export const FETCH_MESSAGE = 'fetch_message';
export const GET_USER_ME = 'get_user_me';
export const CLEAR_USER_ME = 'clear_user_me';
export const CURRENT_GROUPING_CHANGED = 'CURRENT_GROUPING_CHANGED';
